import { combineReducers } from 'redux';
import ordersReducer from './ordersReducer';
import quotesReducer from './quotesReducer';
import myProductsReducer from './myProductsReducer';
import productsReducer from './productsReducer';
import shoppingCartReducer from './shoppingCartReducer';
import yourPrintersReducer from './yourPrintersReducer';
import carouselReducer from './carouselReducer';
import salesReducer from './salesReducer';
import { routerReducer } from 'react-router-redux';

const rootReducer = combineReducers({
  orders: ordersReducer,
  myProducts: myProductsReducer,
  products: productsReducer,
  yourPrinters: yourPrintersReducer,
  shoppingCart: shoppingCartReducer,
  carousel: carouselReducer,
  routing: routerReducer,
  sales: salesReducer,
  quotes: quotesReducer,
});

export default rootReducer;
